export function getCommandPriorityBadgeValue() {
	return {
		label: "Prioritaire",
		textColor: "white",
		backgroundColor: "#dc2626",
		height: "26px",
		borderRadius: 1000,
	};
}
